/**
 * 模組頁面代碼 : 1420-UI-01
 * 頁面說明 : 滿意度調查資料清單列表頁面
 * @module modules/satisfaction-survey/components/SatisfactionSurveyPage
 */

import React, {useEffect, useRef, useState} from 'react';
import {BaseComponent} from 'web/components/BaseComponent';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
  FLG_SEND,
} from 'web/constant';
import enumList from 'web/utils/enumList';
import {showMessage} from 'web/utils/modalHelper';
import {useSatisfactionSurvey} from '../hooks/useSatisfactionSurvey';
import moment from 'moment';
const SatisfactionSurveyPage = (props) => {
  const baseComponent = new BaseComponent(props);
  const tableRef = useRef(null);
  const {dataReloadHandler, dataReload, toggleSatisfactionModal} = props;

  const today = moment();

  const {
    getSurveyList,
    onBatch,
    searchCasePriority,
    searchEndDate,
    searchFlgStatus,
    searchStartDate,
    setSearchCasePriority,
    setSearchEndDate,
    setSearchFlgStatus,
    setSearchStartDate,
  } = useSatisfactionSurvey(
    showMessage,
    () => {},
    baseComponent,
    toggleSatisfactionModal,
  );

  const handleSearch = (e) => {
    e.preventDefault();
    getSurveyList(
      searchCasePriority,
      searchFlgStatus,
      searchStartDate,
      searchEndDate,
    ); // 可改傳參數：searchCasePriority, searchFlgStatus...
  };

  useEffect(() => {
    baseComponent.checkPermission(
      enumList.moduleEnums.case,
      enumList.accessModeEnums.read,
    );
    getSurveyList(searchCasePriority, searchFlgStatus, today, today); // 初始載入
  }, []);

  useEffect(() => {
    if (dataReload) {
      getSurveyList(
        searchCasePriority,
        searchFlgStatus,
        searchStartDate,
        searchEndDate,
      );
      dataReloadHandler();
    }
  }, [dataReload]);

  // 不知道是什麼
  // useEffect(() => {
  //   const handleClick = (event) => {
  //     const button = event.target.closest('.btn');
  //     if (
  //       button &&
  //       button.id.startsWith('survey-detail-') &&
  //       surveyList.length > 0
  //     ) {
  //       const index = parseInt(button.id.split('-')[2]);
  //       const caseNumber = surveyList[index].caseNumber;
  //       navigate(`/module/satisfaction-management/${caseNumber}`);
  //     }
  //   };
  //   if (tableRef.current) {
  //     tableRef.current.addEventListener('click', handleClick);
  //   }
  //   return () => {
  //     if (tableRef.current) {
  //       tableRef.current.removeEventListener('click', handleClick);
  //     }
  //   };
  // }, []);

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg
              className="nav__icon nav__icon--breadcrumb me-3"
              aria-hidden="true"
            >
              <use href="#ico-home-line"></use>
            </svg>
            服務調查
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            滿意度調查
          </li>
        </ol>
      </nav>
      <h4>滿意度調查</h4>
      <div className="datatable__search">
        <form className="d-flex gap-2 align-items-end" onSubmit={handleSearch}>
          <div className="flex-fill w-100">
            <label htmlFor="searchCasePriority" className="form-label">
              等級
            </label>
            <select
              className="form-select form-select-sm"
              id="searchCasePriority"
              value={searchCasePriority}
              onChange={(e) => setSearchCasePriority(e.target.value)}
            >
              <option value="0">全部</option>
              <option value={enumList.casePriority.high}>
                {CASE_PRIORITY_HIGH}
              </option>
              <option value={enumList.casePriority.normal}>
                {CASE_PRIORITY_NORMAL}
              </option>
            </select>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchFlgStatus" className="form-label">
              狀態
            </label>
            <select
              className="form-select form-select-sm"
              id="searchFlgStatus"
              value={searchFlgStatus}
              onChange={(e) => setSearchFlgStatus(e.target.value)}
            >
              <option value="0">全部</option>
              <option value={enumList.satisfactionFlgStatus.open}>
                {FLG_OPEN}
              </option>
              <option value={enumList.satisfactionFlgStatus.send}>
                {FLG_SEND}
              </option>
              <option value={enumList.satisfactionFlgStatus.close}>
                {FLG_CLOSE}
              </option>
            </select>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchStartDate" className="form-label">
              開始日期
            </label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchStartDate"
              value={searchStartDate}
              onChange={(e) => setSearchStartDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchEndDate" className="form-label">
              結束日期
            </label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchEndDate"
              value={searchEndDate}
              onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <div>
            <button className="btn btn-primary" type="submit">
              <svg className="btn__icon" aria-hidden="true">
                <use href="#ico-search"></use>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table
          id="datatable__satisfactionList"
          className="display table table-hover align-middle nowrap"
        ></table>
      </div>
    </section>
  );
};

export default SatisfactionSurveyPage;
